export var SectionHistoryAction = {
    ORDER_HISTORY: 1,
};
